import React, { Component } from 'react';
import { Grid, Row } from 'react-bootstrap';
import NavMenu from './Nav/NavMenu';
import { ToastContainer, Slide } from 'react-toastify';
import BrowserDetection from 'react-browser-detection';

export class Layout extends Component {
    displayName = Layout.name

    render() {
        const browserHandler = {
            ie: () => <div style={{height:'40px', fontSize: '20px', backgroundColor: 'Yellow', textAlign: 'center', verticalAlign: 'middle' }}>Your browser appears incompatible with this website and may cause issues. This site is best viewed using Google Chrome</div>
        };

        return (
            <Grid fluid>
                <Row >
                    <BrowserDetection>
                        {browserHandler}
                    </BrowserDetection>
                    <NavMenu />
                    {this.props.children}
                </Row>
                <Row>
                    <div className="footer">
                        <span>
                            &copy; 2014-{(new Date().getFullYear())} Organically Grown Company. All rights reserved.
                        </span>
                        <span style={{ position: 'absolute', right: '1%', color: 'rgb(72, 60, 44)' }}>v2019.11.06.1</span>
                    </div>
                </Row>
                <ToastContainer transition={Slide} position="top-right" hideProgressBar autoClose={3700} />
            </Grid >
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Layout.js